import {isShopSlug, SHOP_ANIMAL_TITLES} from '~/utils/shopStorefront'

type ShopPageRoute = {params: Record<string, unknown>}

/** Страницы витрины берут slug-и из адреса один раз в setup: другой адрес — другой экземпляр страницы. */
export const shopPageKey = (route: {path: string}): string => route.path

export function validateShopParams(...names: string[]) {
    return (route: ShopPageRoute): boolean => names.every((name) => isShopSlug(route.params[name]))
}

export function validateShopAnimalParams(route: ShopPageRoute): boolean {
    const animal = route.params.animal

    return validateShopParams('section', 'category')(route)
        && typeof animal === 'string'
        && Object.hasOwn(SHOP_ANIMAL_TITLES, animal)
}
